import { render, staticRenderFns } from "./VerifyPhoneSuccess.vue?vue&type=template&id=1bf8ff9e"
import script from "./VerifyPhoneSuccess.vue?vue&type=script&lang=js"
export * from "./VerifyPhoneSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports